import { IMedSolInputProps, MedSolLabeledInput } from '@ms/medsol-components';

interface IDateInputProps extends IMedSolInputProps {}

export function DateInput({ ...rest }: IDateInputProps) {
    return <MedSolLabeledInput type="date" {...rest} />;
}
